<template>
  <div class="container">
    <GameBoard v-bind:seed=seed></GameBoard>
    <Panel v-bind:player=playerData v-bind:inGame=inGame></Panel>
  </div>
</template>

<script>

import Panel from "../components/Panel";
import Player from "../obj/Player";
import GameBoard from "../components/GameBoard";

export default {
  name: 'Game',
  components: {
    Panel, GameBoard
  },
  methods: {

  },
  data() {
    return {
      playerData: Player,
      inGame: true,
      seed: ""
    }
  },
  mounted() {
    this.seed = this.$route.params.seed
  }
}
</script>
